<template>
    <div class="inputText fullname">
        <v-text-field
			class="input-border-inset"
			v-on:input="updateValue($event)"
            v-bind:label="label"
			v-bind:type="type"
			v-bind:value="value"
			v-bind:disabled="disabled"
			v-bind:required="required"
			hide-details
            single-line
        >
        </v-text-field>
    </div>
</template>

<script>
function updateValue(value) {
	this.$emit('input', value);
}
export default {
	props: {
		label: String,
		type: String,
		value: [String, Date, Number, Object],
		disabled: Boolean,
		required: Boolean,
	},
	methods: {
		updateValue,
	},
};
</script>



// WEBPACK FOOTER //
// InputText.vue?64cc65aa